import React, { useMemo } from 'react';
import { TagContext, TagContextProps, tagSlice } from '../context/TagContext';
import { Tag } from '../types/tag/tag';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface TagProviderProps {
  children: React.ReactNode;
}

export default function TagProvider({ children }: TagProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.tags.items);
  const loading = useAppSelector(state => state.tags.loading);

  const tags = useMemo(() => {
    return new Map(items.map(item => [item.id, new Tag(item)]));
  }, [items]);

  const tagContext: TagContextProps = {
    tags,
    tagsLoading: loading,
    setTags: (tags: Map<string, Tag>) => dispatch(tagSlice.actions.setAll([...tags.values()])),
  };

  return <TagContext.Provider value={tagContext}>{children}</TagContext.Provider>;
}
